<template>
  <svg
    id="Capa_1"
    data-name="Capa 1"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewbox"
    :height="height"
    :width="width"
  >
    <polyline
      class="cls-1"
      points="26.32 3.25 15.81 0.53 3.47 3.07 3.47 14.36 13.46 18.93 26.32 14.83 26.32 8.93"
    />
    <line class="cls-1" x1="15.81" y1="0.53" x2="15.81" y2="5.75" />
    <line class="cls-1" x1="13.46" y1="18.93" x2="13.46" y2="6.33" />
    <polyline
      class="cls-1"
      points="13.46 6.47 17.19 11.79 29.68 7.67 26.32 3.25 13.46 6.33 3.47 3.07 0.32 6.69 3.47 6.69"
    />
  </svg>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["dataUser"]),
  },
  props: {
    color: {
      type: String,
      default: "#00000",
    },
    height: {
      type: Number,
      default: 30,
    },
    width: {
      type: Number,
      default: 22,
    },
    viewbox: {
      type: String,
      default: "0 -11 30 22",
    },
  },
};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: #000000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.9px;
}
</style>
